import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { URL_MATCHINGS } from '../service/endpoints';
import { putData } from '../service/APIClient';

export const addMatching = createAsyncThunk(
  'matchings/addMatching',
  async (payload, thunkAPI) => {
    try {
      const { labels, config = {} } = payload;

      const response = await putData(URL_MATCHINGS, { labels }, config);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);



const matchingsSlice = createSlice({
  name: 'matchings',
  initialState: {
    data: [],
    status: 'idle',
    addStatus: 'idle',
    changeStatus: 'idle',
    deleteStatus: 'idle',
    error: null,
    isModalVisible: false
  },
  reducers: {
    openModal: state => {
      state.isModalVisible = true;
    },
    closeModal: state => {
      state.isModalVisible = false;
    },
    resetAddStatus: state => {
      state.addStatus = 'idle';
    }
  },
  extraReducers: builder => {
    builder
      .addCase(addMatching.pending, state => {
        state.addStatus = 'loading';
      })
      .addCase(addMatching.fulfilled, (state, action) => {
        state.addStatus = 'succeeded';
        state.isModalVisible = false;
        state.data.push(action.payload);
      })
      .addCase(addMatching.rejected, (state, action) => {
        state.addStatus = 'failed';
        state.error = action.payload || action.error.message;
      })
  }
});

export default matchingsSlice.reducer;
